import { AdminModel1, UserModel1 } from '../config/types';

export const isAdmin = (currentUser: UserModel1 | null): currentUser is AdminModel1 =>
	!!currentUser && currentUser.role === 'admin';

export const isPostAuthor = (currentUser: UserModel1 | null, authorId: string) =>
	currentUser && currentUser.uid === authorId;

export const isCompanyMember = (currentUser: UserModel1 | null, companyId: string) =>
	currentUser && currentUser.role !== 'admin' && currentUser.companyId === companyId;
